const isValidFieldEntry = (field) =>
	field &&
	typeof field === "object" &&
	typeof field.fieldName === "string" &&
	field.fieldName.length > 0;

export const normalizeFieldOrder = (group) =>
	Array.isArray(group?.fieldOrder)
		? group.fieldOrder.filter(isValidFieldEntry)
		: [];

export const getAvailableFieldsByGroup = (groups, tableFields) => {
	const usedFieldNames = new Set(
		groups.flatMap((group) =>
			normalizeFieldOrder(group).map(({ fieldName }) => fieldName),
		),
	);

	return groups.reduce((availableFields, group) => {
		availableFields[group.id] = tableFields.filter(
			({ heading }) => !usedFieldNames.has(heading),
		);
		return availableFields;
	}, {});
};

export const appendFieldToGroup = (groups, groupId, fieldName) =>
	groups.map((group) =>
		group.id === groupId
			? {
					...group,
					fieldOrder: [
						...normalizeFieldOrder(group),
						{ fieldName },
					],
				}
			: group,
	);
